import { openDB, IDBPDatabase } from "idb";
import { InquiryViewColumns } from "../../shared/constants/globalConstants";

const DB_NAME = "TRM-DB";
const DB_VERSION = 1;


export const dbStore = async (storeName: string,keyPath: string='eKey'): Promise<IDBPDatabase> => {
  const db = await openDB(`${DB_NAME}_${storeName}`, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(storeName)) {
        const store = db.createObjectStore(storeName, { keyPath: keyPath });
        store.createIndex("ItemModified", "ItemModified", { unique: false });
        store.createIndex("modifiedOn", "modifiedOn", { unique: false });
        store.createIndex(InquiryViewColumns.ModifiedOn, InquiryViewColumns.ModifiedOn, { unique: false });
      }
    },
  });
  return db;
};

export const isDBExists = async (storeName: string): Promise<boolean> => {
  const dbName = `${DB_NAME}_${storeName}`;

  if (typeof indexedDB?.databases === "function") {
    const dbs = await indexedDB.databases();
    return dbs.some((db: any) => db.name === dbName);
  }

  return true;
};

export const saveItems = async (storeName: string, items: any[],keyPath: string='eKey') => {
  const db = await dbStore(storeName,keyPath);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);

  // Queue every put on the transaction without awaiting each one individually — awaiting per
  // item forces a full round trip per row, which for thousands of rows keeps this readwrite
  // transaction (and the store lock it holds) open far longer than necessary.
  for (const item of items) {
    store.put(item);
  }

  await tx.done;
  return true;
};


export const getAllItemsInStore = async (storeName: string,keyPath: string='eKey'): Promise<any[]> => {
  const db = await dbStore(storeName,keyPath);
  const tx = db.transaction(storeName, "readonly");
  const store = tx.objectStore(storeName);
  const result = await store.getAll();
  await tx.done;
  return result;
};


export const getLatestModifiedDate = async (storeName: string, basedOn: string,keyPath: string='eKey'): Promise<string | null> => {
  const db = await dbStore(storeName,keyPath);
  const tx = db.transaction(storeName, "readonly");
  const store = tx.objectStore(storeName);
  const index = store.index(basedOn);
  const cursor = await index.openCursor(null, "prev");
  const result = cursor ? cursor.value[basedOn] : null;
  await tx.done;
  return result;
};

export const deleteItemsInStore = async (storeName: string,items: any[],keyPath: string='eKey') => {
  const db = await dbStore(storeName,keyPath);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  // See saveItems: queue deletes without awaiting each one to keep the readwrite lock short-lived.
  for (const item of items) {
  store.delete(item[keyPath]);
  }
  await tx.done;
  return true;
}

export const clearStore = async (storeName: string,keyPath: string='eKey') => {
  const db = await dbStore(storeName,keyPath);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  await store.clear();
  await tx.done;
  return true;
};

export const deleteIDB = async (storeName: string) => {
 indexedDB.deleteDatabase(`${DB_NAME}_${storeName}`);
  return true;
}
